import React from 'react';
import {
    Grid,
    GridSize,
    CheckboxProps,
    Checkbox,
    FormControlLabel
} from '@mui/material';

export interface FormCheckboxProps extends CheckboxProps {
    sx?: React.CSSProperties | undefined;
    lg?: boolean | GridSize | undefined;
    md?: boolean | GridSize | undefined;
    sm?: boolean | GridSize | undefined;
    xs?: boolean | GridSize | undefined;
    label?: string;
    optional?: boolean | undefined;
    children?: React.ReactNode;
}

export const FormCheckbox: React.FC<FormCheckboxProps> = React.memo(
    ({ sx, xs, sm, md, lg, optional, label, children, ...otherProps }) => {
        return (
            <Grid item xs={xs ? xs : 12} sm={sm} md={md} lg={lg}>
                {label ? (
                    <FormControlLabel
                        control={
                            <Checkbox
                                {...otherProps}
                                required={!optional}
                                style={sx}
                            />
                        }
                        label={label}
                    />
                ) : (
                    <Checkbox {...otherProps} required={!optional} style={sx} />
                )}
            </Grid>
        );
    }
);
